export enum CheckboxTheme {
  Blue = `blue`,
  Green = `green`,
  Red = `red`,
  Orange = `orange`,
}
